import React from "react";
import { Layout } from "../components/web-layout/layout";

export default class Terms extends React.Component {
    render() {
        const year = new Date().getFullYear();

        return (
            <Layout>
                <h1>Our Terms of Use</h1>
                <p>
                    Prana Diabetes, Inc. ("Prana Diabetes," the "Company," "we,"
                    "us" or "our") owns and operates the HabitNu website (the
                    "HabitNu Site" or the "Site") to provide information to help
                    manage diabetes through interactive monitoring of diet,
                    exercise and blood sugar levels and enabling the sharing of
                    electronic record keeping with physicians (the "services").
                </p>
                <p>
                    PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY
                    BEFORE USING THIS SITE.
                </p>
                <p>
                    By using the Site, you signify your assent to these Terms
                    and Conditions. If you do not agree to all of these Terms
                    and Conditions of use, do not use the Site.
                </p>
                <p>
                    We may revise and update these Terms and Conditions at any
                    time. Your continued usage of the HabitNu Site will mean you
                    accept those changes.
                </p>
                <p>
                    Your data and certain information about you are subject to
                    our Privacy Policy. Please review our Privacy Policy
                    carefully. The terms of our Privacy Policy are incorporated
                    herein by reference.
                </p>
                <h3>CONTENTS</h3>
                <p>The Site Does Not Provide Medical Advice</p>
                <p>Children's Privacy</p>
                <p>Use of Content</p>
                <p>Liability of Prana Diabetes and Its Licensors</p>
                <p>User Submissions</p>
                <p>User Media Submissions – Image, Video, Audio files</p>
                <p>Passwords</p>
                <p>Prana Diabetes Community and Member to Member Areas</p>
                <p>Advertisements, Search and Links to Other Sites</p>
                <p>Indemnity</p>
                <p>General</p>
                <p>Jurisdiction</p>
                <p>Notice and Take Down Procedures, Copyright Agent</p>
                <p>Complete Agreement</p>
                <p> </p>
                <p>The Site Does Not Provide Medical Advice</p>
                <p>
                    The contents of the HabitNu Site, such as text, graphics,
                    images, information obtained from Prana Diabetes' licensors,
                    and other material contained on the HabitNu Site ("Content")
                    are for informational purposes only. The Content is not
                    intended to be a substitute for professional medical advice,
                    diagnosis, or treatment. Always seek the advice of your
                    physician or other qualified health provider with any
                    questions you may have regarding a medical condition. Never
                    disregard professional medical advice or delay in seeking it
                    because of something you have read on the HabitNu Site.
                </p>
                <p>
                    If you think you may have a medical emergency, call your
                    doctor or emergency medical service immediately. Prana
                    Diabetes does not recommend or endorse any specific tests,
                    physicians, products or procedures. Reliance on any
                    information provided by Prana Diabetes, Prana Diabetes
                    employees, consultants, contributors or others appearing on
                    the Site at the invitation of Prana Diabetes, or other
                    visitors to the Site is solely at your own risk.
                </p>
                <h3>Children's Privacy</h3>
                <p>
                    We are committed to protecting the privacy of children. You
                    should be aware that this Site is not intended or designed
                    to attract children under the age of 13. We do not collect
                    personally identifiable information from any person we
                    actually know is a child under the age of 13.
                </p>
                <h3>Use of Content</h3>
                <p>
                    Prana Diabetes authorizes you to view or download a single
                    copy of the material on the HabitNu Site solely for your
                    personal, non-commercial use if you include the following
                    copyright notice: "
                    <span dangerouslySetInnerHTML={{ __html: "&copy;" }} />
                    {year}, Prana Diabetes, Inc. All rights reserved" and other
                    copyright and proprietary rights notices that are contained
                    in the Content. Any special rules for the use of certain
                    software and other items accessible on the Site may be
                    included elsewhere within the Site and are incorporated into
                    these Terms and Conditions by reference.
                </p>
                <p>
                    The Content is protected by copyright laws. Title to the
                    Content remains with Prana Diabetes or its licensors. Any
                    use of the Content not expressly permitted by these Terms
                    and Conditions is a breach of these Terms and Conditions and
                    may violate copyright, trademark, and other laws. Content
                    and features are subject to change or termination without
                    notice in the editorial discretion of Prana Diabetes. All
                    rights not expressly granted herein are reserved to Prana
                    Diabetes and its licensors.
                </p>
                <p>
                    If you violate any of these Terms and Conditions, your
                    permission to use the Content automatically terminates and
                    you must immediately destroy any copies you have made of any
                    portion of the Content.
                </p>
                <h3>
                    Liability of Prana Diabetes and Its Licensors; Disclaimers
                </h3>
                <p>
                    The use of the HabitNu Site and the Content is at your own
                    risk.
                </p>
                <p>
                    When using the HabitNu Site, information will be transmitted
                    over a medium that may be beyond the control and
                    jurisdiction of Prana Diabetes and its suppliers.
                    Accordingly, Prana Diabetes assumes no liability for or
                    relating to the delay, failure, interruption, or corruption
                    of any data or other information transmitted in connection
                    with use of the Site.
                </p>
                <p>
                    The HabitNu Site and the content are provided on an "as is"
                    basis. PRANA DIABETES, ITS LICENSORS, AND ITS SUPPLIERS, TO
                    THE FULLEST EXTENT PERMITTED BY LAW, DISCLAIM ALL
                    WARRANTIES, EITHER EXPRESS OR IMPLIED, STATUTORY OR
                    OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED
                    WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT OF THIRD
                    PARTIES' RIGHTS, FITNESS FOR PARTICULAR PURPOSE, COURSE OF
                    DEALING OR COURSE OF PERFORMANCE. Without limiting the
                    foregoing, Prana Diabetes, its licensors, and its suppliers
                    make no representations or warranties about the following:
                </p>
                <ol>
                    <li>
                        <p>
                            The accuracy, reliability, completeness,
                            currentness, or timeliness of the Content, software,
                            text, graphics, links, or communications provided on
                            or through the use of the HabitNu Site.
                        </p>
                    </li>
                    <li>
                        <p>
                            The quality of any products or services identified
                            on the Site.
                        </p>
                    </li>
                    <li>
                        <p>
                            The satisfaction of any government regulations
                            requiring disclosure of information on prescription
                            drug products or the approval or compliance of any
                            software tools with regard to the Content contained
                            on the HabitNu Site.
                        </p>
                    </li>
                </ol>
                <p>
                    YOU ARE SOLELY RESPONSIBLE FOR, AND ASSUME ALL RISKS OF, ALL
                    ONLINE OR OFFLINE COMMUNICATIONS AND INTERACTIONS ON THE
                    COMPONENTS OF THE SITE AND WITH PERSONS WITH WHOM YOU
                    COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SITE.
                </p>
                <p>
                    You expressly understand that Prana Diabetes shall not be
                    liable for any direct, indirect, incidental, special,
                    consequential or exemplary damages, including, but not
                    limited to, damages for loss of profits, goodwill, use, data
                    or other intangible losses (even if Prana Diabetes has been
                    advised of the possibility of such damages). In no event
                    shall Prana Diabetes, its licensors, its suppliers, or any
                    third parties mentioned on the HabitNu Site be liable for
                    any damages (including, without limitation, incidental and
                    consequential damages, personal injury/wrongful death, lost
                    profits, or damages resulting from lost data or business
                    interruption) resulting from the use of or inability to use
                    the HabitNu Site or the Content, whether based on warranty,
                    contract, tort, or any other legal theory. Prana Diabetes,
                    its licensors, its suppliers, or any third parties mentioned
                    on the HabitNu Site shall be liable only to the extent of
                    actual damages incurred by you, not to exceed the amount
                    actually paid by you to Prana Diabetes during the preceding
                    12 months. Prana Diabetes, its licensors, its suppliers, or
                    any third parties mentioned on the HabitNu Site are not
                    liable for any personal injury, including death, caused by
                    your use or misuse of the Site, Content, or Public Areas (as
                    defined below). Any claims arising in connection with your
                    use of the Site, any Content, or the Public Areas must be
                    brought within one (1) year of the date of the event giving
                    rise to such action occurred. Remedies under these Terms and
                    Conditions are exclusive and are limited to those expressly
                    provided for in these Terms and Conditions.
                </p>
                <h3>User Submissions</h3>
                <p>
                    The personal information you submit to Prana Diabetes is
                    governed by the Prana Diabetes Privacy Policy. To the extent
                    there is an inconsistency between this Agreement and the
                    Prana Diabetes Privacy Policy, this Agreement shall govern.
                </p>
                <p>
                    The Site may contain functionality that allows users to
                    upload content to the Site (collectively "Public Areas").
                    You agree that you will not upload or transmit any
                    communications or content of any type to the Public Areas
                    that infringe or violate any rights of any party. By
                    submitting communications or content to the Public Areas,
                    you agree that such submission is non-confidential for all
                    purposes.
                </p>
                <p>
                    If you make any such submission you agree that you will not
                    send or transmit to Prana Diabetes by email, (including
                    through the email addresses listed on the "Contact" page)
                    any communication or content that infringes or violates any
                    rights of any party. If you submit any business information,
                    idea, concept or invention to Prana Diabetes by email, you
                    agree such submission is non-confidential for all purposes.
                </p>
                <p>
                    If you make any submission to a Public Area or if you submit
                    any business information, idea, concept or invention to
                    Prana Diabetes by email, you automatically grant-or warrant
                    that the owner of such content or intellectual property has
                    expressly granted Prana Diabetes a royalty-free, perpetual,
                    irrevocable, world-wide non-exclusive license to use,
                    reproduce, create derivative works from, modify, publish,
                    edit, translate, distribute, perform, and display the
                    communication or content in any media or medium, or any
                    form, format, or forum now known or hereafter developed.
                    Prana Diabetes may sublicense its rights through multiple
                    tiers of sublicenses. If you wish to keep any business
                    information, ideas, concepts or inventions private or
                    proprietary, do not submit them to the Public Areas or to
                    Prana Diabetes by email. We try to answer every email in a
                    timely manner, but are not always able to do so.
                </p>
                <p>
                    Prana Diabetes is under no obligation to monitor the
                    accuracy or reliability of user submissions and has no
                    control over the representations or actions of its users.
                    Although these Terms and Conditions require users to provide
                    accurate information, we do not attempt to confirm, and do
                    not confirm, any user's purported identity or submission.
                    You are responsible for evaluating the information provided
                    on the Site.
                </p>
                <h3>User Submissions — Image, Video, Audio Files</h3>
                <p>
                    You agree to only post or upload Media (such as photos,
                    videos or audio) that you have taken yourself or that you
                    have all rights to transmit and license and which do not
                    violate trademark, copyright, privacy or any other rights of
                    any other person. Photos or videos of celebrities and
                    cartoon or comic images are usually copyrighted by the
                    owner.
                </p>
                <p>
                    To protect your privacy, you agree that you will not submit
                    any media that contains Personally Identifiable Information
                    (such as name, phone number, email address or web site URL)
                    of you or of anyone else. Uploading media like images or
                    video of other people without their permission is strictly
                    prohibited.
                </p>
                <p>
                    By uploading any media on the HabitNu Site, you warrant that
                    you have permission from all persons appearing in your media
                    for you to make this contribution and grant rights described
                    herein. Never post a picture or video of or with someone
                    else unless you have their explicit permission.
                </p>
                <p>
                    It is strictly prohibited to upload media of any kind that
                    contain expressions of hate, abuse, violence, offensive
                    images or conduct, obscenity, pornography, sexually explicit
                    material, any material that promotes harmful or illegal
                    activity or any material that could give rise to any civil
                    or criminal liability under applicable law or regulations or
                    that otherwise may be in conflict with these Terms and
                    Conditions or the Prana Diabetes Privacy Policy.
                </p>
                <p>
                    You agree that you will not upload any material that
                    contains software viruses or any other computer code, files
                    or programs designed to interrupt, destroy or limit the
                    functionality of any computer software or this Site.
                </p>
                <p>
                    By uploading any media like a photo or video, (a) you grant
                    to Prana Diabetes a perpetual, non-exclusive, worldwide,
                    royalty-free license to use, copy, print, display,
                    reproduce, modify, publish, post, transmit and distribute
                    the media and any material included in the media; (b) you
                    certify that any person pictured in the submitted media (or,
                    if a minor, his/her parent/legal guardian) authorizes Prana
                    Diabetes to use, copy, print, display, reproduce, modify,
                    publish, post, transmit and distribute the media and any
                    material included in such media; and (c) you agree to
                    indemnify Prana Diabetes and its affiliates, directors,
                    officers and employees and hold them harmless from any and
                    all claims and expenses, including attorneys' fees, arising
                    from the media and/or your failure to comply with these
                    Terms and Conditions.
                </p>
                <p>
                    Prana Diabetes reserves the right to review all media prior
                    to submission to the site and to remove any media for any
                    reason, at any time, without prior notice, at our sole
                    discretion.
                </p>
                <h3>Passwords</h3>
                <p>
                    Prana Diabetes has several tools that allow you to record
                    and store information. You are responsible for taking all
                    reasonable steps to ensure that no unauthorized person shall
                    have access to your Prana Diabetes passwords or accounts. It
                    is your sole responsibility to (1) control the dissemination
                    and use of sign-in name, screen name and passwords; (2)
                    authorize, monitor, and control access to and use of your
                    Prana Diabetes account and password; (3) promptly inform
                    Prana Diabetes if you believe your account or password has
                    been compromised or if there is any other reason you need to
                    deactivate a password. To send us an email, use the
                    "Contact" links located at the bottom of the home page of
                    the Site. You grant Prana Diabetes and all other persons or
                    entities involved in the operation of the Site the right to
                    transmit, monitor, retrieve, store, and use your information
                    in connection with the operation of the Site. Prana Diabetes
                    cannot and does not assume any responsibility or liability
                    for any information you submit, or your or third parties'
                    use or misuse of information transmitted or received using
                    Prana Diabetes tools and services.
                </p>
                <h3>Public Areas</h3>
                <p>
                    If you use a message board, blog or other member communities
                    ("Public Areas"), you are solely responsible for your own
                    communications, the consequences of posting those
                    communications, and your reliance on any communications
                    found in the Public Areas. Prana Diabetes and its licensors
                    are not responsible for the consequences of any
                    communications in the Public Areas. In cases where you feel
                    threatened or believe someone else is in danger, you should
                    contact your local law enforcement agency immediately. If
                    you think you may have a medical emergency, call your doctor
                    or emergency medical service immediately.
                </p>
                <p>
                    In consideration of being allowed to use the Public Areas,
                    you agree that the following actions shall constitute a
                    material breach of these Terms and Conditions:
                </p>
                <ol>
                    <li>
                        <p>
                            Using a Public Area for any purpose in violation of
                            local, state, national, or international laws;
                        </p>
                    </li>
                    <li>
                        <p>
                            Posting material that infringes on the intellectual
                            property rights of others or on the privacy or
                            publicity rights of others;
                        </p>
                    </li>
                    <li>
                        <p>
                            Reproducing, duplicating, copying, reverse
                            engineering, selling, reselling or exploiting any
                            portion of the Site without the express written
                            permission of Prana Diabetes;
                        </p>
                    </li>
                    <li>
                        <p>
                            Posting material that is unlawful, obscene,
                            defamatory, threatening, harassing, abusive,
                            slanderous, hateful, or embarrassing to any other
                            person or entity as determined by Prana Diabetes in
                            its sole discretion;
                        </p>
                    </li>
                    <li>
                        <p>
                            Posting advertisements or solicitations of business;
                        </p>
                    </li>
                    <li>
                        <p>
                            After receiving a warning, continuing to disrupt the
                            normal flow of dialogue, or posting comments that
                            are not related to the topic being discussed (unless
                            it is clear the discussion is free-form);
                        </p>
                    </li>
                    <li>
                        <p>Posting chain letters or pyramid schemes;</p>
                    </li>
                    <li>
                        <p>Impersonating another person;</p>
                    </li>
                    <li>
                        <p>
                            Distributing viruses, worms or other harmful
                            computer code;
                        </p>
                    </li>
                    <li>
                        <p>
                            Harvesting, scraping or otherwise collecting
                            information about others, including email addresses,
                            without their identification for posting or viewing
                            comments;
                        </p>
                    </li>
                    <li>
                        <p>
                            Allowing any other person or entity to use your
                            identification for posting or viewing comments;
                        </p>
                    </li>
                    <li>
                        <p>
                            Interfering with or disrupting (or attempting to do
                            so) the access of any user, host or network or by
                            scripting the creation of content in such a manner
                            as to interfere with or create an undue burden on
                            the Site;
                        </p>
                    </li>
                    <li>
                        <p>
                            Posting the same note more than once or "spamming";
                            or
                        </p>
                    </li>
                    <li>
                        <p>
                            Engaging in any other conduct that restricts or
                            inhibits any other person from using or enjoying the
                            Public Area or the Site, or which, in the judgment
                            of Prana Diabetes, exposes Prana Diabetes or any of
                            its customers or suppliers to any liability or
                            detriment of any type.
                        </p>
                    </li>
                </ol>
                <p>
                    Prana Diabetes reserves the right (but is not obligated) to
                    do any or all of the following:
                </p>
                <ol>
                    <li>
                        <p>Record the dialogue in public chat rooms.</p>
                    </li>
                    <li>
                        <p>
                            Investigate an allegation that a communication does
                            not conform to the terms of this section and
                            determine in its sole discretion to remove or
                            request the removal of the communication.
                        </p>
                    </li>
                    <li>
                        <p>
                            Remove communications which are abusive, illegal, or
                            disruptive, or that otherwise fail to conform with
                            these Terms and Conditions.
                        </p>
                    </li>
                    <li>
                        <p>
                            Terminate a user's access to any or all Public Areas
                            and/or the HabitNu Site upon any breach of these
                            Terms and Conditions.
                        </p>
                    </li>
                    <li>
                        <p>
                            Monitor, edit, or disclose any communication in the
                            Public Areas.
                        </p>
                    </li>
                    <li>
                        <p>
                            Edit or delete any communication posted on the
                            HabitNu Site, regardless of whether such
                            communication violates these standards.
                        </p>
                    </li>
                </ol>
                <p>
                    Prana Diabetes and its licensors have no liability or
                    responsibility to users of the HabitNu Site or any other
                    person or entity for performance or nonperformance of the
                    aforementioned activities.
                </p>
                <h3>Advertisements, Searches, and Links to Other Sites</h3>
                <p>
                    Prana Diabetes may provide links to third-party web sites.
                    Prana Diabetes also may select certain sites as priority
                    responses to search terms you enter and Prana Diabetes may
                    agree to allow advertisers to respond to certain search
                    terms with advertisements or sponsored content. Prana
                    Diabetes does not recommend and does not endorse the content
                    on any third-party websites. Prana Diabetes is not
                    responsible for the content of linked third-party sites,
                    sites framed within the HabitNu Site, third-party sites
                    provided as search results, or third-party advertisements,
                    and does not make any representations regarding their
                    content or accuracy. Your use of third-party websites is at
                    your own risk and subject to the terms and conditions of use
                    for such sites. Prana Diabetes does not endorse any product,
                    service, or treatment advertised on the HabitNu Site.
                </p>
                <h3>Indemnity</h3>
                <p>
                    You agree to defend, indemnify, and hold Prana Diabetes, its
                    officers, directors, employees, agents, licensors, and
                    suppliers, harmless from and against any claims, actions or
                    demands, liabilities and settlements including without
                    limitation, reasonable legal and accounting fees, resulting
                    from, or alleged to result from, or in any way connected
                    with (i) your access to or use of the Site; (ii) your
                    violation of these Terms and Conditions; (iii) your
                    violation of any third party right, including, without
                    limitation, any intellectual property right, publicity,
                    confidentiality, property or privacy right by you; or (iv)
                    your use of the Site .
                </p>
                <h3>General</h3>
                <p>
                    Prana Diabetes is based in Chicago, Illinois, in the United
                    States of America with principal offices in Chicago,
                    Illinois and with offices and certain affiliated companies
                    in India. Prana Diabetes makes no claims that Prana Diabetes
                    or the Content are appropriate or may be downloaded outside
                    of the United States or India. Access to the Content may not
                    be legal by certain persons or in certain countries. If you
                    access the Site from outside the United States or India, you
                    do so at your own risk and are responsible for compliance
                    with the laws of your jurisdiction.
                </p>
                <p>
                    The following provisions survive the expiration or
                    termination of this Agreement for any reason whatsoever:
                    Liability, User Submissions, User Submissions – image,
                    video, audio files, Indemnity, Jurisdiction, and Complete
                    Agreement.
                </p>
                <h3>Jurisdiction</h3>
                <p>
                    You expressly agree that exclusive jurisdiction for any
                    dispute with Prana Diabetes, or in any way relating to your
                    use of the Site, resides in the courts of the State of
                    Illinois and you further agree and expressly consent to the
                    exercise of personal jurisdiction in the courts of the State
                    of Illinois in connection with any such dispute including
                    any claim involving Prana Diabetes or its affiliates,
                    subsidiaries, employees, contractors, officers, directors,
                    telecommunication providers, and content providers.
                </p>
                <p>
                    These Terms and Conditions are governed by the internal
                    substantive laws of the State of Illinois, without respect
                    to its conflict of laws principles. If any provision of
                    these Terms and Conditions is found to be invalid by any
                    court having competent jurisdiction, the invalidity of such
                    provision shall not affect the validity of the remaining
                    provisions of these Terms and Conditions, which shall remain
                    in full force and effect. No waiver of any of these Terms
                    and Conditions shall be deemed a further or continuing
                    waiver of such term or condition or any other term or
                    condition.
                </p>
                <h3>Notice and Takedown Procedures; and Copyright Agent</h3>
                <p>
                    If you believe any materials accessible on or from the Site
                    infringe your copyright, you may request removal of those
                    materials (or access thereto) from this web site by
                    contacting Prana Diabetes' copyright agent (identified
                    below) and providing the following information:
                </p>
                <ol>
                    <li>
                        <p>
                            Identification of the copyrighted work that you
                            believe to be infringed. Please describe the work,
                            and where possible include a copy or the location
                            (e.g., URL) of an authorized version of the work.
                        </p>
                    </li>
                    <li>
                        <p>
                            Identification of the material that you believe to
                            be infringing and its location. Please describe the
                            material, and provide us with its URL or any other
                            pertinent information that will allow us to locate
                            the material.
                        </p>
                    </li>
                    <li>
                        <p>
                            Your name, address, telephone number and (if
                            available) e-mail address.
                        </p>
                    </li>
                    <li>
                        <p>
                            A statement that you have a good faith belief that
                            the complained of use of the materials is not
                            authorized by the copyright owner, its agent, or the
                            law.
                        </p>
                    </li>
                    <li>
                        <p>
                            A statement that the information that you have
                            supplied is accurate, and indicating that "under
                            penalty of perjury," you are the copyright owner or
                            are authorized to act on the copyright owner's
                            behalf.
                        </p>
                    </li>
                    <li>
                        <p>
                            A signature or the electronic equivalent from the
                            copyright holder or authorized representative.
                        </p>
                    </li>
                </ol>
                <p>
                    Prana Diabetes' agent for copyright issues relating to this
                    web site is as follows:
                </p>
                <p>Bart Loethen</p>
                <p>Synergy Law Group, LLC</p>
                <p>730 W. Randolph Street</p>
                <p>Suite 600</p>
                <p>Chicago, IL 60661</p>
                <p>312.454.0015</p>
                <p>bart@synergylawgroup.com</p>
                <p>
                    In an effort to protect the rights of copyright owners,
                    Prana Diabetes maintains a policy for the termination, in
                    appropriate circumstances, of subscribers and account
                    holders of the Site who are repeat infringers.
                </p>
                <h3>Complete Agreement</h3>
                <p>
                    Except as expressly provided in a particular "legal notice"
                    on the HabitNu Site, these Terms and Conditions and the
                    Prana Diabetes Privacy Policy constitute the entire
                    agreement between you and Prana Diabetes with respect to the
                    use of the Site and Content.
                </p>
                <p> </p>
                <blockquote>Last Updated: September 18, 2016</blockquote>
                <br />
                <p className="text-center mt-2">
                    <a href="/">Login</a>
                </p>
            </Layout>
        );
    }
}
